/* eslint-disable react/no-unused-state */

import './VideoPopup.style';

import { PureComponent } from 'react';

import Popup from 'Component/Popup';
import { MediaItemType } from 'Type/ProductList';
import { makeCancelable } from 'Util/Promise';

import { VIDEO_POPUP_ID, VIMEO_FORMAT, YOUTUBE_FORMAT } from './VideoPopup.config';
import { VideoPopup as SourceVideoPopup } from 'SourceComponent/VideoPopup/VideoPopup.component';

/**
 * A popup capable of displaying a video
 * @class VideoPopup
 */
export class VideoPopup extends SourceVideoPopup {
    static propTypes = {
        payload: MediaItemType.isRequired
    };

    componentDidMount() {
        this.loadVimeoLibrary();
        this.loadYouTubeLibrary();

        Promise.all([
            this.vimeoPromise,
            this.youTubePromise
        ]).then(() => {
            this.forceUpdate();
        });
    }

    componentWillUnmount() {
        if (this.youTubePromise) {
            this.youTubePromise.cancel();
        }

        if (this.vimeoPromise) {
            this.vimeoPromise.cancel();
        }
    }

    _renderVideoContent() {
        const {
            payload: {
                media: {
                    video_content: { video_url } = {}
                } = {}
            }
        } = this.props;

        if (!video_url) {
            return null;
        }

        const [, vimeoId] = VIMEO_FORMAT.exec(video_url) || [];
        if (vimeoId) {
            return this._renderVimeoVideo(vimeoId);
        }

        const [, youtubeId] = YOUTUBE_FORMAT.exec(video_url);
        if (youtubeId) {
            return this._renderYoutubeVideo(youtubeId);
        }

        return null;
    }
}

export default VideoPopup;
